import AnimatedLayout from 'components/layouts/animated-layout';
import { SettingsContentHeader } from 'components/layouts/settings-workspace/settings-workspace';
import HelmetTabComponent from 'components/helmet-tab/helmet-tab';
import { AddressesList } from 'features/profile';

const AdressesTab = (): JSX.Element => {
    return (
        <AnimatedLayout>
            <HelmetTabComponent title="آدرس ها" />

            <SettingsContentHeader
                title="آدرس ها"
                description="آدرس‌های محل سکونت و محل کار خود را برای خدمات حساب مدیریت کنید."
            />

            <AddressesList />
        </AnimatedLayout>
    );
};

export default AdressesTab;
